module.exports = __webpack_public_path__ + "img/unit_RedMetallic.bffda15e.png";